import React from 'react'
import styled from 'styled-components'
import { LoadingPlaceholder } from '@sketch/components'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  width: 100%;
`

/**
 * Shown while the inspector sidebar is being fetched.
 *
 * Deliberately built from `@sketch/components` rather than the inspector's own
 * skeleton: the skeleton lives in `@sketch/inspector/ui`, and importing it here
 * would pull the very chunk this fallback exists to wait for.
 */
export const InspectorLoading = () => (
  <Container>
    <LoadingPlaceholder size="64px" />
  </Container>
)
